import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Shocked2 } from '../assets/shocked2.svg?react'

export function PageUnauthorized() {
  const { t } = useTranslation()
  return (
    <div className='p-8 w-full text-center'>
      <div className='font-bold text-4xl leading-[2] flex-cc mb-4'>
        <div>{t('Oops!')}</div>
        <Shocked2 className='dark:fill-slate-900' width={64} height={64} />
      </div>
      <div className='text-base w-full'>
        <div className='max-w-[480px] m-auto'>
          {t(
            "You don't have permission to view this page. Please contact organization administrator to get access permission."
          )}
        </div>
      </div>
    </div>
  )
}
